import SvgIcon from './SvgIcon';

// eslint-disable-next-line react/prop-types
const IconOutlineAltitude = ({ fill = '#32353B', stroke = '#32353B' }) => {
  return (
    <SvgIcon title="Aiming Higher Icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        fill="none"
      >
        <rect
          width="46.33"
          height="46.33"
          x=".33"
          y=".33"
          stroke={stroke}
          strokeOpacity=".2"
          strokeWidth=".67"
          rx="11.67"
        />
        <path
          fill={fill}
          d="M29 22v-4.2l-1.6 1.6L26 18l4-4 4 4-1.4 1.43-1.6-1.6V22h-2ZM12 32l6-8 4.5 6H30l-5-6.65-2.5 3.3L21.25 25 25 20l9 12H12Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default IconOutlineAltitude;
